var _path, _polyline, _path2, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f25f1276-e8ff-4e43-9b6f-15fe788321c5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.99991 44.00006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-circle-trash") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,0A22,22,0,1,0,43.99991,22,22.02487,22.02487,0,0,0,22,0",
    fill: "#ff4000",
    opacity: 0.1
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "15 16.556 16.556 16.556 29 16.556",
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.44441,16.55558V27.44447A1.55555,1.55555,0,0,1,25.88886,29H18.11108a1.55555,1.55555,0,0,1-1.55555-1.55556V16.55558m2.33333,0V15a1.55555,1.55555,0,0,1,1.55555-1.55556h3.11112A1.55556,1.55556,0,0,1,25.11108,15v1.55555",
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20.44441,
    y1: 20.44447,
    x2: 20.44441,
    y2: 25.11114,
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.55553,
    y1: 20.44447,
    x2: 23.55553,
    y2: 25.11114,
    fill: "none",
    stroke: "#ff4000",
    strokeLinecap: "square",
    strokeWidth: 1.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTrash);
export default __webpack_public_path__ + "static/media/circle-trash.c74285f74aa0e70e55bdaff2c6ee48bb.svg";
export { ForwardRef as ReactComponent };